import * as React from "react";
import { ThemeProvider as StyledComponentThemeProvider } from "styled-components";
import { ITheme } from "./Theme";

interface IProps {
  theme: ITheme;
}

class ThemeProviderView extends React.PureComponent<IProps> {
  public render() {
    const { theme } = this.props;
    return (
      <StyledComponentThemeProvider theme={theme ? theme : {}}>
        {this.props.children}
      </StyledComponentThemeProvider>
    );
  }
}

export { ThemeProviderView };
